// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {FetchTravelersSuccess} from 'redux/v1/travelers/data/actions';
import type {DataState} from 'redux/v1/travelers/data/DataState';
import type {Traveler} from 'redux/v1/travelers/data/models';
import type {DeleteTravelersSuccess} from 'redux/v1/travelers/delete/actions';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {FETCH_TRAVELERS} from 'redux/v1/travelers/data/actions';
import {prepareTravelers} from 'redux/v1/travelers/data/utils';
import {DELETE_TRAVELERS} from 'redux/v1/travelers/delete/actions';
import {PUT_TRAVELERS} from 'redux/v1/travelers/put/actions';
import {dataState} from 'redux/v1/travelers/TravelersState';

export const initialState: DataState = {
  loading: false,
};

const actionCreators: ActionHandlers<DataState> = {
  [PENDING(FETCH_TRAVELERS)]: (state: DataState) => ({
    ...state,
    loading: true,
  }),
  [SUCCESS(FETCH_TRAVELERS)]: (
    state: DataState,
    action: FetchTravelersSuccess
  ) => ({
    ...state,
    loading: false,
    data: action.data === undefined ? [] : prepareTravelers(action.data),
  }),
  [ERROR(FETCH_TRAVELERS)]: (state: DataState, action: any) => ({
    ...state,
    loading: false,
    error: action?.error.toJSON(),
  }),
  [SUCCESS(PUT_TRAVELERS)]: (
    state: DataState,
    action: FetchTravelersSuccess
  ) => ({
    ...state,
    loading: false,
    data: action.travelers,
  }),
  [SUCCESS(DELETE_TRAVELERS)]: (
    state: DataState,
    action: DeleteTravelersSuccess
  ) => ({
    ...state,
    data: null,
  }),
};

export const dataReducer: Reducer<DataState> = // $FlowIgnore
  createReducerUsingActionHandlers<DataState>(initialState, actionCreators);

export const isDataLoaded: Selector<boolean> = createSelector(
  dataState,
  (state: DataState) => !state.loading && state.data !== undefined
);

export const isDataEmpty: Selector<boolean> = createSelector(
  [dataState, isDataLoaded],
  (state: DataState, loaded: boolean) =>
    !loaded || !state.data || state.data.length === 0
);

export const getData: Selector<Traveler[]> = createSelector(
  [dataState, isDataLoaded],
  (state: DataState, loaded: boolean) =>
    loaded && state.data ? state.data : []
);
